import {decryption, encryption} from "./cipherUtil";
import {VERSION_ERROR} from "./store/error"
import Vue from "vue"

// 接続先 ローカル
export const LOCAL = "http://192.168.1.21:8000/"
// 接続先 開発
export const DEVELOP = "http://dev-scibai.m-craft.com/"
// 接続先 本番
export const PRODUCTION = "https://api.mirai-scien.com/"

let access_point = PRODUCTION

// ベーシック認証
export const BASIC_AUTH_API_USER_NAME = "scibai"
export const BASIC_AUTH_API_PASSWORD = "87ts9UQ8Mpkd"

// ステータスコード
export const OK = 200

// アプリバージョン
export const CLIENT_VERSION = '2.2.0'

let user_id = 0

let session_id = null

// 暗号化有無
const CIPHER = true

// デバッグモード
export const DEBUG_MODE = false

export function getUrl(callback) {
	let config = requestHeaderConfig()
	axios.get(getAccessPoint() + 'get_url', config)
		.then(function (response) {
			if(response.status !== OK) {
				navigator.notification.alert(
					response.message,
					() => {
						this.$router.push('/').catch(error => {})
					},
					'エラーコード:'+VERSION_ERROR,
					'OK'
				)
			}
			// 正常
			else {
				if(CIPHER) {
					response.data = decryption(response.data)
				}
				response = errorCheck(response)
				let jsonData = JSON.parse(response.data)
                if (jsonData['error'] !== undefined) {
                    return
                }
				access_point = jsonData.api_url
				callback()
			}
		})
}

export function getAccessPoint() {
	return access_point
}

export function generateGetUrl(url, data)
{
	return url + "?data=" + encodeURIComponent(JSON.stringify(data))
}

export function setHeaderUser(trn_user_id)
{
	user_id = trn_user_id;
}

export function setSessionId(sessionId)
{
	session_id = sessionId
}

export function requestHeaderConfig()
{
	if (user_id === 0 && session_id === null) {
		NativeStorage.getItem('profile', value => {
			if (value.trn_user_id !== undefined) {
				user_id = value.trn_user_id
			}
			if (value.session_id !== undefined) {
				session_id = value.session_id
			}
		})
	}
	let config = {
		headers: {"X-USER-ID": user_id, "X-CLIENT-VERSION": CLIENT_VERSION},
		auth: {username: BASIC_AUTH_API_USER_NAME, password: BASIC_AUTH_API_PASSWORD}
	}
	if (session_id !== null) {
		config.headers["X-SESSION-ID"] = session_id
	}
	if (Vue.cordova.device.platform === 'browser') {
		config.headers["X-DEVICE-TYPE"] = 1
	}
	return config
}

export function requestDeleteConfig(data)
{
	return {
		data: JSON.stringify(data),
		headers: {"X-USER-ID": user_id, "X-CLIENT-VERSION": CLIENT_VERSION},
		auth: {username: BASIC_AUTH_API_USER_NAME, password: BASIC_AUTH_API_PASSWORD}
	}
}

export async function postApi(api, data){
	let config = requestHeaderConfig()
	if(CIPHER) {
		data = encryption(data)
	}
	let response = await axios.post(getAccessPoint() + api + '/', data, config)
    if (response.status === OK) {
        if(CIPHER) {
            response.data = decryption(response.data)
        }
        response = errorCheck(response)
    }
    return  response
}

export async function getApi (api, data) {
	let config = requestHeaderConfig()
	if(CIPHER) {
		data = encryption(data)
	}
	const url = generateGetUrl(getAccessPoint() + api + '/', data)
	let response = await axios.get(url, config)
    if (response.status === OK) {
        if(CIPHER) {
            response.data = decryption(response.data)
        }
        response = errorCheck(response)
    }
    return  response
}

export async function putApi (api, data) {
	let config = requestHeaderConfig()
	if(CIPHER) {
		data = encryption(data)
	}
	let response = await axios.put(getAccessPoint() + api + '/', data, config)
    if (response.status === OK) {
        if(CIPHER) {
            response.data = decryption(response.data)
        }
        response = errorCheck(response)
    }
    return response
}

export async function deleteApi(api, data) {
	if (CIPHER && null != data) {
		data = encryption(data)
	}
	let config = requestDeleteConfig(data)
	let response = await axios.delete(getAccessPoint() + api + '/', config)
    if (response.status === OK) {
        if(CIPHER) {
            response.data = decryption(response.data)
        }
        response = errorCheck(response)
    }
    return response
}

function errorCheck(response) {
	var jsonData = null
	if('string' === typeof response.data) {
		jsonData = JSON.parse(response.data)
	}
	else  {
		jsonData = response.data
	}
	if (jsonData['error'] === undefined) {
		return response
	}
	response.status = jsonData.error.code
	response.message = jsonData.error.message
	return response
}

export function trace_log(data) {
	if (DEBUG_MODE) {
		console.log(data)
	}
}